import { useViewCurrentUserProfileQuery } from '@/api/profile';

export const useAllowRememberCard = () => {
  const { data: profile } = useViewCurrentUserProfileQuery();

  return profile?.allowRememberCard || false;
};
